import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDocumentTitle } from 'usehooks-ts';

import ContentLayout from '@/layouts/ContentLayout';
import { useNotFoundContext } from '@/pages/not-found/use-not-found-context';
import { getRoutePath } from '@/routes/util';
import { ANALYTICS_EVENTS } from '@/shared/analytics/events';
import { getDocumentTitle } from '@/shared/i18n';
import { EmptyState, Flex } from '@kognitos/lattice';

function NotFound() {
  const { t } = useTranslation('common');
  useDocumentTitle(getDocumentTitle(t('common.notFound.title')));
  const navigate = useNavigate();
  const context = useNotFoundContext();
  const { logEvent } = useStatsigClient();

  // eslint-disable-next-line no-restricted-syntax -- reason: Log analytics on mount
  useEffect(() => {
    try {
      logEvent(ANALYTICS_EVENTS.NOT_FOUND_PAGE_VIEWED, '', {
        attempted_path: context.attemptedPath,
        referrer: context.referrer,
        org_id: context.orgId ?? 'none',
        workspace_id: context.workspaceId ?? 'none',
      });
    } catch {
      // Global catch-all route may lack Statsig provider
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoHome = () => {
    navigate(getRoutePath('HOME'));
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <ContentLayout testId="not-found-page">
      <Flex justify="center" align="center" width="full" height="full">
        <EmptyState
          icon="AlertCircle"
          title={t('common.notFound.title')}
          description={t('common.notFound.subtitle')}
          actionLabel={t('common.action.goHome')}
          onAction={handleGoHome}
          secondaryActionLabel={t('common.action.goBack')}
          onSecondaryAction={handleGoBack}
          className="w-full max-w-md"
        />
      </Flex>
    </ContentLayout>
  );
}

export const Component = NotFound;
